import Vue from 'vue'
import Router from 'vue-router'
import Introduction from '@/components/Introduction'
import Menu from '@/components/Menu'

// becoming donator
import Donator_step1 from '@/components/donator/Step1'
import Donator_step2 from '@/components/donator/Step2'
import Donator_thankyou from '@/components/donator/Thankyou'

// becoming donator
import Donate_step1 from '@/components/donate/Step1'
import Donate_step2 from '@/components/donate/Step2'
import Donate_thankyou from '@/components/donate/Thankyou'

// more info
import About from '@/components/more_info/about'
import Staff from '@/components/more_info/staff'
import Research from '@/components/more_info/research'
import Donate from '@/components/more_info/donate'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Introduction',
      component: Introduction
    },
    {
      path: '/menu',
      name: 'Menu',
      component: Menu
    },
    {
      path: '/more_info/about',
      name: 'About',
      component: About
    },
    {
      path: '/more_info/staff',
      name: 'Staff',
      component: Staff
    },
    {
      path: '/more_info/donate',
      name: 'Donate',
      component: Donate
    },
    {
      path: '/more_info/research',
      name: 'Research',
      component: Research
    },
    {
      path: '/donator/step1',
      name: 'Donator_step1',
      component: Donator_step1
    },
    {
      path: '/donator/step2',
      name: 'Donator_step2',
      component: Donator_step2
    },
    {
      path: '/donator/thankyou',
      name: 'Donator_thankyou',
      component: Donator_thankyou
    },
    {
      path: '/donate/step1',
      name: 'Donate_step1',
      component: Donate_step1
    },
    {
      path: '/donate/step2',
      name: 'Donate_step2',
      component: Donate_step2
    },
    {
      path: '/donate/thankyou',
      name: 'Donate_thankyou',
      component: Donate_thankyou
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js